import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Appeal from './pages/Appeal';
import AppealHistory from './pages/AppealHistory';
import AppealDetail from './pages/AppealDetail';
import ProtectedRoute from './components/ProtectedRoute';
import IdleTimeout from './components/IdleTimeout';

// Wraps a protected page with both the auth check (ProtectedRoute) and the
// idle-timeout warning/auto-logout (IdleTimeout). ProtectedRoute is outermost
// so unauthenticated visits redirect to /login before the idle timer ever starts.
function Protected({ children }) {
  return (
    <ProtectedRoute>
      <IdleTimeout>
        {children}
      </IdleTimeout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        {/* Accounts are invitation-only, so the old sign-up address goes to login. */}
        <Route path="/signup" element={<Navigate to="/login" replace />} />
        <Route
          path="/appeal"
          element={
            <Protected>
              <Appeal />
            </Protected>
          }
        />
        <Route
          path="/appeal-history"
          element={
            <Protected>
              <AppealHistory />
            </Protected>
          }
        />
        <Route
          path="/appeal-detail/:id"
          element={
            <Protected>
              <AppealDetail />
            </Protected>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;